import styled from "styled-components";

export const ImageList = styled.ul`
    padding-top: 76px;
    padding-left: 15px;
    padding-right: 15px;
    @media screen and (min-width: 768px) {
        display: flex;
        flex-wrap: wrap;
        margin-left: -15px;
    }
`
